import type { ReactNode } from 'react';
import { TdToastProps, Toast } from 'tdesign-mobile-react';
import {
  Loading,
  MessageInfoMethod,
  MessageInfoOptions,
  MessagePlugin,
  MessageThemeList,
} from 'tdesign-react';
import { CautionFilled, SuccessFilled } from '@tencent/oneid-icons';
import { PREFIX } from 'common/constants/Constants';
import JSRuntime from 'common/utils/JSRuntime';

type TMessageOptions = MessageInfoOptions | string;

const iconMap = {
  success: <SuccessFilled style={{ color: `var(--${PREFIX}-color-success-primary)` }} />,
  warning: <CautionFilled style={{ color: `var(--${PREFIX}-color-warning-primary)` }} />,
  error: <CautionFilled style={{ color: `var(--${PREFIX}-color-error-primary)` }} />,
  info: <SuccessFilled style={{ color: `var(--${PREFIX}-color-success-primary)` }} />,
  loading: <Loading />,
};

const toast = (props: TMessageOptions, theme?: TdToastProps['theme']) => {
  const message = typeof props === 'string' ? props : props.content;

  return Toast({
    preventScrollThrough: false,
    direction: 'column',
    message,
    theme,
  });
};

const mobileMethods = {
  success: (props: TMessageOptions) => toast(props, 'success'),
  warning: (props: TMessageOptions) => toast(props, 'warning'),
  error: (props: TMessageOptions) => toast(props, 'error'),
  // @ts-ignore
  loading: (props: TMessageOptions) => toast(props, 'loading'),
};

const InternalMessage = {} as typeof MessagePlugin;

// 记录上传提示的信息
const lastContent: { current?: ReactNode } = {};

const message = new Proxy(InternalMessage, {
  get: (target: typeof MessagePlugin, method: MessageThemeList): MessageInfoMethod => {
    if (JSRuntime.isMobileUI) {
      let _method = method;
      if (method === 'info' || method === 'question') {
        _method = 'success';
      }
      return mobileMethods[_method];
    }
    MessagePlugin.config({
      offset: [0, 28],
      icon: iconMap[method],
    });
    return (...rest) => {
      const curContent = typeof rest[0] === 'object' ? rest[0].content : rest[0];
      // 如果和上次信息一致，则清空弹出框
      if (curContent === lastContent.current) {
        MessagePlugin.closeAll();
      }
      lastContent.current = curContent;
      return MessagePlugin[method](...rest);
    };
  },
});

export default message;
